<template>
  <div class="editor-gjs">
    <div id="gjs" />
    <div class="editor-actions">
      <VBtn @click="applyRedacting" color="primary">
        {{ $t('save') }}
      </VBtn>

      <VBtn @click="publishTemplate" color="primary">
        {{ $t('publish') }}
      </VBtn>

      <VBtn
        @click="openDialogResetTemplate"
        color="error"
        class="reset-btn"
      >
        {{ $t('reset') }}
      </VBtn>
    </div>

    <VDialog v-model="showDialogResetCode" max-width="500px" class="reset-code-dialog">
      <VCard>
        <div class="reset-code-dialog__wrap">
          <div class="reset-code-dialog__wrap-text">
            {{ $t('dialogResetCode.message') }}
          </div>
          <div class="reset-code-dialog__wrap-actions">
            <VBtn color="error" variant="text" @click="confirmSaveCode">
              {{ $t('dialogResetCode.reset') }}
            </VBtn>
            <VBtn variant="text" class="cancel-btn" @click="closeDialogResetCode">
              {{ $t('dialogResetCode.cancel') }}
            </VBtn>
          </div>
          <VBtn
            icon
            small
            absolute
            top
            right
            class="reset-code-dialog__close-btn"
            @click="closeDialogResetCode"
          >
            <VIcon>mdi-close</VIcon>
          </VBtn>
        </div>
      </VCard>
    </VDialog>

    <VDialog v-model="showDialogResetTemplate" max-width="500px" class="reset-template-dialog">
      <VCard>
        <div class="reset-template-dialog__wrap">
          <div class="reset-template-dialog__wrap--title">
            {{ $t('dialogResetTemplate.title') }}
          </div>
          <div class="reset-template-dialog__wrap--text">
            {{ $t('dialogResetTemplate.message1') }}
            <br>
            {{ $t('dialogResetTemplate.message2') }}
          </div>
          <div class="reset-template-dialog__wrap--actions">
            <VBtn color="error" variant="text" @click="resetEditor">
              {{ $t('dialogResetTemplate.reset') }}
            </VBtn>
            <VBtn variant="text" class="cancel-btn" @click="closeDialogResetTemplate">
              {{ $t('dialogResetTemplate.cancel') }}
            </VBtn>
          </div>
          <VBtn
            icon
            small
            absolute
            top
            right
            class="reset-template__close-btn"
            @click="closeDialogResetCode"
          >
            <VIcon>mdi-close</VIcon>
          </VBtn>
        </div>
      </VCard>
    </VDialog>

    <VDialog v-model="showDialogTariffPlan" persistent max-width="500">
      <VCard>
        <DialogTariffChange :title="$t('dialogTariffPlan.title')" @close="cancelDialogTariffPlan" />
      </VCard>
    </VDialog>
  </div>
</template>

<script>
import useNotificationMailEditorMixin from '@/mixins/useMailTemplateEditorMixin';
import DialogTariffChange from '@/components/DialogTariffChange.vue';

export default {
  name: 'MailTemplateEditor',
  components: { DialogTariffChange },
  mixins: [useNotificationMailEditorMixin],
  props: {
    isShowCodeEditor: {
      type: Boolean,
      default: false,
    },
    company: {
      type: Object,
      required: true,
    },
    account: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
.gjs-block {
  justify-content: center !important;
}

.gjs-pn-views-container,
.gjs-pn-views {
  width: 20%;
}

.gjs-cv-canvas {
  width: 80%;
}

#gjs {
  background: #fff !important;
  color: #000 !important;
  height: 456px;
  border: 1px solid #ccc;
}

.gjs-pn-options {
  right: 20%;
}

.gjs-one-bg {
  background-color: #f8f8f8 !important;
}

.gjs-two-bg {
  background-color: #fff !important;
}

.gjs-three-bg {
  background-color: #f0f0f0 !important;
}

.gjs-four-bg {
  background-color: #e6e6e6 !important;
}

.gjs-sm-label,
.gjs-cl-label,
.gjs-layer-title,
.gjs-pn-btn,
.gjs-block-label,
.gjs-field,
.gjs-category-title,
.gjs-block,
.gjs-two-color,
.gjs-sm-field input {
  color: #000 !important;
  font-weight: 500;
}

.gjs-pn-btn {
  color: #333 !important;
}

.gjs-pn-btn:hover {
  color: #000 !important;
  background: #e6e6e6 !important;
}

.gjs-pn-btn.gjs-pn-active {
  color: #000 !important;
  background: #dcdcdc !important;
}

.gjs-block {
  background: #fff !important;
  color: #000 !important;
  border: 1px solid #ddd !important;
}

.gjs-block:hover {
  background: #f0f0f0 !important;
}

.gjs-pn-panel {
  background: #f8f8f8 !important;
}

.gjs-pn-views-container {
  background: #fff !important;
}

.gjs-sm-sector .gjs-sm-title {
  color: #000 !important;
}

.gjs-layer-title {
  color: #000 !important;
}

.gjs-layer {
  background: #fff !important;
}

.gjs-block-search {
  background: #fff !important;
  color: #000 !important;
  border: 1px solid #ddd !important;
}

.gjs-trt-trait {
  color: #000 !important;
}

.gjs-trt-trait input,
.gjs-field {
  background: #fff !important;
  color: #000 !important;
  border: 1px solid #ddd !important;
}

.gjs-rte-toolbar {
  background: #fff !important;
  color: #000 !important;
}

.gjs-rte-toolbar .gjs-btn {
  color: #333 !important;
}

.gjs-rte-toolbar .gjs-btn:hover {
  background: #e6e6e6 !important;
  color: #000 !important;
}

.simple-mode .gjs-pn-commands,
.simple-mode .gjs-cv-canvas {
  width: 100% !important;
}
.simple-mode .gjs-pn-options {
  right: 0;
}

.simple-mode .gjs-highlight-selected,
.simple-mode .gjs-toolbar {
  display: none !important;
}

.sp-choose {
  --gjs-font-color: #fff !important;
}

.fa-repeat {
  display: none;
}

.editor-actions {
  margin-top: 12px;
}
@media screen and (max-width: 428px) {
  .editor-gjs {
    min-height: 720px;
    padding-bottom: 84px;
  }
  .gjs-pn-views-container {
    height: 300px;
  }
}
@media screen and (max-width: 1240px) {
  .gjs-cv-canvas,
  .gjs-pn-commands {
    width: 60%;
  }
  .gjs-pn-options {
    right: 40%;
  }
  .gjs-pn-views,
  .gjs-pn-views-container {
    width: 40%;
  }

  .gjs-pn-devices-c,
  .gjs-pn-commands {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .editor-page {
    padding-bottom: 66px;
  }

  .editor-gjs {
    min-height: 900px;
  }
  .simple-mode .editor-gjs {
    min-height: 486px;
  }

  .save-button {
    position: absolute;
    bottom: 0px;
  }

  .gjs-pn-views,
  .gjs-pn-views-container {
    top: 100%;
    width: 100%;
  }

  .gjs-cv-canvas,
  .gjs-pn-commands {
    width: 100%;
  }

  .gjs-pn-options {
    right: 0;
  }

  .gjs-pn-views-container {
    height: 365px;
  }
}

@media screen and (max-width: 428px) {
  .gjs-pn-views-container {
    height: 355px;
  }
}

@media screen and (max-width: 350px) {
  #gjs {
    height: 710px !important;
  }
}
</style>

<style lang="scss" scoped>

.editor-actions .v-btn:not(:first-child) {
  margin-left: 8px;
}
@media screen and (max-width: 768px) {
  .editor-actions {
    position: abs($number: 0);
    bottom: 0;
  }
}

@media screen and (max-width: 428px) {
  .editor-actions {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 12px;
    background: #ffffff;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    z-index: 10;
  }
  .editor-actions .v-btn {
    width: 100%;
    margin: 0 !important;
  }
}

.reset-code-dialog {
  &__wrap {
    @media screen and (max-width: 768px) {
      max-height: 300px;
    }
    padding: 30px;
    position: relative;
  }
  &__wrap-text {
    max-width: 330px;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 30px;
  }
  &__wrap-actions {
    display: flex;
    gap: 12px;
  }
  &__close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }
}

.reset-template-dialog {
  &__wrap {
    @media screen and (max-width: 768px) {
      max-height: 300px;
    }
    padding: 30px;
    position: relative;
    &--title {
      font-size: 25px;
      line-height: 120%;
      margin-bottom: 20px;
      max-width: 360px;
    }

    &--text {
      max-width: 330px;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 30px;
    }

    &--actions {
      display: flex;
      gap: 12px;
    }
  }
  &__close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }
}
</style>

<i18n locale="en" lang="yaml">
save: Save
publish: Publish
reset: Reset template
undo: Undo
editCode: Edit code
editingCode: Editing code
changeMode: Change Mode
viewComponents: View components
preview: Preview
fullscreen: Fullscreen
saved: Saved
published: Published
templateReset: Template reset
openStyleManager: Open Style Manager
dialogTariffPlan:
  title: Publishing a letter is not available on your plan.
dialogResetCode:
  message: Your code is missing a required dedicated block for it to work correctly.
  reset: Reset code
  cancel: Cancel
dialogResetTemplate:
  title:  Reset all design changes?
  message1: Are you sure you want to revert the design to its original state?
  message2: All changes you’ve made will be permanently deleted and cannot be recovered.
  reset: Yes, reset
  cancel: Cancel
editor:
  codeWarning: "You can edit <b>only the email code</b> here. The block <code>SELECTED BLOCK</code> must always remain in place for correct operation."
blockedTemplate:
  hello: 'Hello!'
  text1: This text and its elements serve only as a visual example of what the email will look like.
  text2: To make changes to the email content, go to the "Email Templates" page, select the desired template, and edit its text.
  text3: Don't forget to enable the mailing — only then will the candidate receive the email.
</i18n>

<i18n locale="ru" lang="yaml">
save: Сохранить
publish: Опубликовать
reset: Сбросить шаблон
undo: Отменить
editCode: Редактировать код
editingCode: Редактирование кода
changeMode: Сменить режим
viewComponents: Отображение блоков
preview: Предпросмотр
fullscreen: Полноэкранный режим
saved: Сохранено
published: Опубликовано
templateReset: Шаблон сброшен
openStyleManager: Открыть менеджер cтилей
dialogTariffPlan:
  title: Публикация письма недоступна на вашем тарифе
dialogResetCode:
  message: В вашем коде отсутствует необходимый выделенный блок для корректной работы
  reset: Сбросить код
  cancel: Отмена
dialogResetTemplate:
  title: Сбросить все изменения оформления?
  message1: Вы действительно хотите вернуть оформление к исходному виду?
  message2: Все внесённые изменения будут удалены без возможности восстановления.
  reset: Да, сбросить
  cancel: Отмена
editor:
  codeWarning: "Здесь можно редактировать <b>только код письма</b>. Блок <code>ВЫДЕЛЕННЫЙ БЛОК</code> всегда должен оставаться на месте для корректной работы."
blockedTemplate:
  hello: 'Здравствуйте!'
  text1: Этот текст и элементы служат лишь визуальным примером того, как будет выглядеть письмо.
  text2: Чтобы внести изменения в текст письма, перейдите на страницу «Шаблоны писем», выберите нужное письмо и отредактируйте его текст.
  text3: Не забудьте включить рассылку — только в этом случае кандидат получит письмо.
</i18n>